// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterModal_root__272ib","submit":"FooterModal_submit__gZRv_","cancel":"FooterModal_cancel__yqkXt"};